var map = {
	"./brady.jpg": 1217,
	"./gif-brady.gif": 9215,
	"./gif-nick.gif": 7082,
	"./gif-paul.gif": 1031,
	"./nick.jpg": 7246,
	"./paul.jpg": 2866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3545;